/**
 * Sickle contract ABIs
 * These will be extracted from Foundry's out/ directory when contracts are compiled
 *
 * For now, we'll use minimal ABIs for Phase 1 POC.
 * Full ABIs can be extracted from packages/sickle-contracts/out/ after compilation.
 */
// Minimal ABI for SickleFactory - just what we need for Phase 1
export const SickleFactoryAbi = [
    {
        inputs: [
            { internalType: 'address', name: 'approved', type: 'address' },
            { internalType: 'bytes32', name: 'referralCode', type: 'bytes32' },
        ],
        name: 'deploy',
        outputs: [{ internalType: 'address', name: 'sickle', type: 'address' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: 'owner', type: 'address' }],
        name: 'sickles',
        outputs: [{ internalType: 'address', name: 'sickle', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'address', name: 'owner', type: 'address' },
            { indexed: true, internalType: 'address', name: 'sickle', type: 'address' },
        ],
        name: 'Deploy',
        type: 'event',
    },
    {
        inputs: [{ internalType: 'address', name: 'owner', type: 'address' }],
        name: 'predict',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
];
// Minimal ABI for Sickle - multicall function
export const SickleAbi = [
    {
        inputs: [
            {
                components: [
                    { internalType: 'address', name: 'target', type: 'address' },
                    { internalType: 'bytes', name: 'callData', type: 'bytes' },
                ],
                internalType: 'struct Multicall.Call[]',
                name: 'calls',
                type: 'tuple[]',
            },
        ],
        name: 'multicall',
        outputs: [
            { internalType: 'bytes[]', name: 'returnData', type: 'bytes[]' },
        ],
        stateMutability: 'payable',
        type: 'function',
    },
];
// Minimal ABI for SimpleFarmStrategy - deposit and withdraw
export const SimpleFarmStrategyAbi = [
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            { internalType: 'address', name: 'stakingContract', type: 'address' },
                            { internalType: 'uint256', name: 'poolIndex', type: 'uint256' },
                        ],
                        internalType: 'struct Farm',
                        name: 'farm',
                        type: 'tuple',
                    },
                    { internalType: 'address[]', name: 'tokensIn', type: 'address[]' },
                    { internalType: 'uint256[]', name: 'amountsIn', type: 'uint256[]' },
                    { internalType: 'bytes', name: 'extraData', type: 'bytes' },
                ],
                internalType: 'struct DepositParams',
                name: 'params',
                type: 'tuple',
            },
        ],
        name: 'deposit',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                components: [
                    { internalType: 'bytes', name: 'extraData', type: 'bytes' },
                    { internalType: 'address[]', name: 'tokensOut', type: 'address[]' },
                ],
                internalType: 'struct WithdrawParams',
                name: 'params',
                type: 'tuple',
            },
        ],
        name: 'withdraw',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
];
// Minimal ABI for FarmStrategy - deposit and increase with zap
export const FarmStrategyAbi = [
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            { internalType: 'address', name: 'stakingContract', type: 'address' },
                            { internalType: 'uint256', name: 'poolIndex', type: 'uint256' },
                        ],
                        internalType: 'struct Farm',
                        name: 'farm',
                        type: 'tuple',
                    },
                    { internalType: 'address[]', name: 'tokensIn', type: 'address[]' },
                    { internalType: 'uint256[]', name: 'amountsIn', type: 'uint256[]' },
                    {
                        components: [
                            {
                                components: [
                                    { internalType: 'address', name: 'router', type: 'address' },
                                    { internalType: 'uint256', name: 'amountIn', type: 'uint256' },
                                    { internalType: 'uint256', name: 'minAmountOut', type: 'uint256' },
                                    { internalType: 'address', name: 'tokenIn', type: 'address' },
                                    { internalType: 'bytes', name: 'extraData', type: 'bytes' },
                                ],
                                internalType: 'struct SwapParams[]',
                                name: 'swaps',
                                type: 'tuple[]',
                            },
                            {
                                components: [
                                    { internalType: 'address', name: 'router', type: 'address' },
                                    { internalType: 'address', name: 'lpToken', type: 'address' },
                                    { internalType: 'address[]', name: 'tokens', type: 'address[]' },
                                    { internalType: 'uint256[]', name: 'desiredAmounts', type: 'uint256[]' },
                                    { internalType: 'uint256[]', name: 'minAmounts', type: 'uint256[]' },
                                    { internalType: 'bytes', name: 'extraData', type: 'bytes' },
                                ],
                                internalType: 'struct AddLiquidityParams',
                                name: 'addLiquidityParams',
                                type: 'tuple',
                            },
                        ],
                        internalType: 'struct ZapIn',
                        name: 'zap',
                        type: 'tuple',
                    },
                    { internalType: 'bytes', name: 'extraData', type: 'bytes' },
                ],
                internalType: 'struct DepositParams',
                name: 'params',
                type: 'tuple',
            },
            {
                components: [
                    { internalType: 'bytes32', name: 'rewardSettings', type: 'bytes32' },
                    { internalType: 'bytes32', name: 'exitSettings', type: 'bytes32' },
                ],
                internalType: 'struct PositionSettings',
                name: 'positionSettings',
                type: 'tuple',
            },
            { internalType: 'address[]', name: 'sweepTokens', type: 'address[]' },
            { internalType: 'address', name: 'approved', type: 'address' },
            { internalType: 'bytes32', name: 'referralCode', type: 'bytes32' },
        ],
        name: 'deposit',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            { internalType: 'address', name: 'stakingContract', type: 'address' },
                            { internalType: 'uint256', name: 'poolIndex', type: 'uint256' },
                        ],
                        internalType: 'struct Farm',
                        name: 'farm',
                        type: 'tuple',
                    },
                    { internalType: 'address[]', name: 'tokensIn', type: 'address[]' },
                    { internalType: 'uint256[]', name: 'amountsIn', type: 'uint256[]' },
                    {
                        components: [
                            {
                                components: [
                                    { internalType: 'address', name: 'router', type: 'address' },
                                    { internalType: 'uint256', name: 'amountIn', type: 'uint256' },
                                    { internalType: 'uint256', name: 'minAmountOut', type: 'uint256' },
                                    { internalType: 'address', name: 'tokenIn', type: 'address' },
                                    { internalType: 'bytes', name: 'extraData', type: 'bytes' },
                                ],
                                internalType: 'struct SwapParams[]',
                                name: 'swaps',
                                type: 'tuple[]',
                            },
                            {
                                components: [
                                    { internalType: 'address', name: 'router', type: 'address' },
                                    { internalType: 'address', name: 'lpToken', type: 'address' },
                                    { internalType: 'address[]', name: 'tokens', type: 'address[]' },
                                    { internalType: 'uint256[]', name: 'desiredAmounts', type: 'uint256[]' },
                                    { internalType: 'uint256[]', name: 'minAmounts', type: 'uint256[]' },
                                    { internalType: 'bytes', name: 'extraData', type: 'bytes' },
                                ],
                                internalType: 'struct AddLiquidityParams',
                                name: 'addLiquidityParams',
                                type: 'tuple',
                            },
                        ],
                        internalType: 'struct ZapIn',
                        name: 'zap',
                        type: 'tuple',
                    },
                    { internalType: 'bytes', name: 'extraData', type: 'bytes' },
                ],
                internalType: 'struct DepositParams',
                name: 'params',
                type: 'tuple',
            },
            { internalType: 'address[]', name: 'sweepTokens', type: 'address[]' },
        ],
        name: 'increase',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
];
// Export all ABIs
export const abis = {
    SickleFactory: SickleFactoryAbi,
    Sickle: SickleAbi,
    SimpleFarmStrategy: SimpleFarmStrategyAbi,
    FarmStrategy: FarmStrategyAbi,
};
